module.exports = __webpack_public_path__ + "img/3.6c8f6c7e.jpg";